import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useLocalizer } from '../hooks';
import FeedBackPrompt from './FeedbackPrompt/FeedbackPrompt';
import { RenderInDevelopmentOnly } from './RenderInDevelopmentOnly';
import { TabDefinition, Tabs } from './Shared/Tabs/Tabs';

import { localizationNavMenu } from '../assets/localizations/localizationNavMenu';
import { mainNavMenu } from './Layout';

export const NavMenu = () => {
  const { typeSafeL } = useLocalizer('NavMenu');
  const localization = typeSafeL<typeof localizationNavMenu>;

  const location = useLocation();
  const navigate = useNavigate();

  const tabs: TabDefinition[] = [
    {
      id: 0,
      label: localization('bankAccounts'),
      title: localization('bankAccounts'),
    },
    {
      id: 1,
      label: localization('caseManagement'),
      title: localization('caseManagement'),
    },
  ];

  const handleTabOnSelect = (n: number): void => {
    if (location.pathname !== mainNavMenu[n]) {
      navigate(mainNavMenu[n], { preventScrollReset: true });
    }
  };

  const currentNavIndex = mainNavMenu.findIndex((l) => l === location.pathname);

  return (
    <>
      <FeedBackPrompt studyId="startPage" firstButtonBlue />

      <Tabs aria-label={localization('menuAriaLabel')} tabs={tabs} handleTabOnSelect={(i) => handleTabOnSelect(i)} overrideSelection={currentNavIndex ?? 0}></Tabs>

      <RenderInDevelopmentOnly>
        <div className="m-3 inline-flex items-center rounded-full border border-sky-300 bg-white px-3 py-2 text-sm font-medium text-sky-900 shadow-sm">
          <span className="mr-2 uppercase tracking-[0.14em] text-[11px] text-sky-700">Dev</span>
          <Link to="/mock-forms" className="!text-sky-900 underline underline-offset-4">
            Mock forms index
          </Link>
        </div>
      </RenderInDevelopmentOnly>
    </>
  );
};
